import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import apiClient from '../api/axios';
import { Form, Button, Card, Alert } from 'react-bootstrap';

const ResetPasswordPage = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (newPassword !== confirmPassword) {
            setError('Пароли не совпадают.');
            return;
        }

        setLoading(true);
        setMessage('');
        setError('');

        try {
            const response = await apiClient.post('/users/reset-password', { token, new_password: newPassword });
            setMessage(response.data.message + ' Вы будете перенаправлены на страницу входа через 3 секунды.');
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            if (err.response?.data?.detail && Array.isArray(err.response.data.detail)) {
                setError(err.response.data.detail[0].msg);
            } else {
                const errorMessage = err.response?.data?.detail || 'Произошла ошибка. Возможно, ваша ссылка недействительна или устарела.';
                setError(errorMessage);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
                <Card className="shadow-sm">
                    <Card.Body>
                        <h2 className="card-title text-center mb-4">Установка нового пароля</h2>
                        {message ? (
                            <Alert variant="success">{message}</Alert>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                {error && <Alert variant="danger">{error}</Alert>}
                                <Form.Group className="mb-3" controlId="newPassword">
                                    <Form.Label>Новый пароль</Form.Label>
                                    <Form.Control
                                        type="password"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        required
                                        autoFocus
                                    />
                                    <Form.Text className="text-muted">
                                        Мин. 8 символов, 3 из 4 категорий: латинские буквы (a-z), прописные (A-Z), цифры (0-9), спецсимволы (!@#$%^&*()_+-=[]{}|).
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="confirmPassword">
                                    <Form.Label>Подтвердите новый пароль</Form.Label>
                                    <Form.Control
                                        type="password"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        required
                                    />
                                </Form.Group>
                                <div className="d-grid">
                                    <Button variant="primary" type="submit" disabled={loading}>
                                        {loading ? 'Сохранение...' : 'Сменить пароль'}
                                    </Button>
                                </div>
                            </Form>
                        )}
                         {!message && (
                            <div className="text-center mt-3">
                                <small><Link to="/login">Вернуться ко входу</Link></small>
                            </div>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
};

export default ResetPasswordPage;
